import React from "react";

export default function ClockIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      style={{ right: "8px" }}
    >
      <path
        d="M6 2.625C6 2.41789 5.83211 2.25 5.625 2.25C5.41789 2.25 5.25 2.41789 5.25 2.625V6.75C5.25 6.88457 5.32211 7.00883 5.43895 7.07559L8.06395 8.57559C8.24377 8.67834 8.47284 8.61587 8.57559 8.43605C8.67834 8.25623 8.61587 8.02716 8.43605 7.92441L6 6.53238V2.625Z"
        fill="#3E4957"
      />
      <path
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.1005 11.25 0.75 8.8995 0.75 6C0.75 3.1005 3.1005 0.75 6 0.75C8.8995 0.75 11.25 3.1005 11.25 6Z"
        fill="#3E4957"
      />
    </svg>
  );
}
